import { render } from "./AboutArea.vue?vue&type=template&id=4ebf5da6"
import script from "./AboutArea.vue?vue&type=script&lang=js"
export * from "./AboutArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__